 export function logout() {
    // Kullanıcı bilgilerini yerel depolamadan sil
    localStorage.removeItem('user');
  }
 